import {
  getLandingPageList,
  createLandingPage,
  updateLandingPage,
  publishLandingPage,
} from '../services/api';

// const mockData = {
//   "templateType": 1,
//   "wechatMiniProgramUrl": "8gitw",
//   "buttonColor": "#ff0000",
//   "landingPage": "i3dil",
//   "callLink": "24ufq",
//   "updateTime": "2023-10-16 21:27:19",
//   "title": "22oug",
//   "button": "kubgq",
//   "uid": 97,
//   "forwardType": 1,
//   "createTime": "2026-06-30 23:37:36",
//   "picList": [
//     "ypzt4",
//   ],
//   "wechatMiniProgramId": "u17es",
//   "name": "epx1w",
//   "sponsorUid": 12,
//   "landingPageUrl": "k0p1s",
//   "status": 91,
// };

export default {
  namespace: 'builder',

  state: {
    pageListData: {
      total: 1,
      list: [],
    },
    loading: false,
  },

  effects: {
    *getPageList({ payload }, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(getLandingPageList, payload);
      yield put({
        type: 'loadPageListData',
        payload: response,
      });
      yield put({
        type: 'changeLoading',
        payload: false,
      });
    },
    *createPage({ payload, callback }, { call, put }) {
      const response = yield call(createLandingPage, payload);
      if (callback) {
        callback(response);
      }
    },
    *updatePage({ payload, callback }, { call, put }) {
      const response = yield call(updateLandingPage, payload);
      if (callback) {
        callback(response);
      }
    },
    *publishPage({ payload, callback }, { call, put }) {
      const response = yield call(publishLandingPage, payload);
      if (callback) {
        callback(response);
      }
    },
  },

  reducers: {
    loadPageListData(state, action) {
      return {
        ...state,
        pageListData: action.payload,
      };
    },
    changeLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
  },
};
